export const SET_USER = "SET_USER";
export const SET_TERMS_CONDITIONS = "SET_TERMS_CONDITIONS";
export const SET_SHOW_PASSWORD_MODAL = "SET_SHOW_PASSWORD_MODAL";
